import axios from "./../../config/axios";

function search(query) {
    return axios().get("/sales-scheduling/customers-search", {
        params: {
            query
        }
    })
}

export default {
    search
}